import { Box, CircularProgress, Grid2, IconButton, styled } from '@mui/material'
import { FC } from 'react'
import AddIcon from '@/assets/icons/actions/add.svg'
import { PurchaseRequestData } from './PurchaseRequestData'
import { useMaintenanceTicketsContext } from '@/context/MaintenanceTicketsContext'

type Attachment = {
  id: number
  fileName: string
  presignedUrl: string
  fileType: string
  attachmentType: string
}

type PurchaseRequest = {
  purchaseRequestNumber: string | number
  attachments: Attachment[]
}

interface PurchaseRequestProps {
  purchaseRequestData: PurchaseRequest[]
  setPurchaseRequestData: React.Dispatch<
    React.SetStateAction<PurchaseRequest[]>
  >
  ticketId: number
  disabled: boolean
}

const IconButtonStyled = styled(IconButton)({
  outline: 'none',
  '&:focus': {
    outline: 'none',
  },
})

export const PurchaseRequestForm: FC<PurchaseRequestProps> = ({
  purchaseRequestData,
  setPurchaseRequestData,
  ticketId,
  disabled,
}) => {
  const { purchaseRequestState } = useMaintenanceTicketsContext()
  const handleAddPurchaseRequest = () => {
    setPurchaseRequestData([
      ...purchaseRequestData,
      {
        purchaseRequestNumber: '',
        attachments: [],
      },
    ])
  }

  const handleDeleteQuotation = (index: number) => {
    setPurchaseRequestData((prev) => prev.filter((_value, i) => i !== index))
  }

  const handleChange = (
    index: number,
    field: string,
    value: string | boolean | number | Attachment | Attachment[],
  ) => {
    setPurchaseRequestData((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item
        return { ...item, [field]: value }
      }),
    )
  }

  const handleAddAttachment = (index: number, value: Attachment) => {
    setPurchaseRequestData((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item

        return {
          ...item,
          attachments: [...(item.attachments || []), value],
        }
      }),
    )
  }

  const handleDelete = (attachmentIndex: number, index: number) => {
    setPurchaseRequestData((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item

        return {
          ...item,
          attachments: item.attachments.filter(
            (_, idx) => idx !== attachmentIndex,
          ),
        }
      }),
    )
  }
  console.log('PURCHASE REQUEST', purchaseRequestState.isLoading)
  return (
    <Box>
      {purchaseRequestState.isLoading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress size={24} color="inherit" />
        </Box>
      ) : (
        <>
          {purchaseRequestData.map((data, index) => (
            <Box key={index}>
              <PurchaseRequestData
                data={data}
                onChange={handleChange}
                disabled={false}
                onDelete={handleDeleteQuotation}
                handleAddAttachment={handleAddAttachment}
                handleDeleteAttachment={handleDelete}
                index={index}
                ticketId={ticketId}
              />
            </Box>
          ))}
          {!disabled && (
            <Grid2 container display="flex" justifyContent="center">
              <IconButtonStyled onClick={handleAddPurchaseRequest}>
                <img src={AddIcon} alt="View" width={30} height={30} />
              </IconButtonStyled>
            </Grid2>
          )}
        </>
      )}
    </Box>
  )
}
